import React from 'react'
import { BaseView, StickyHeaderNavigation } from '@/components'
import { ChooseMethodHeader, IdentificationMethods } from '@/features'
import { useNavigate } from 'react-router-dom'

export const IdentificationMethodScreen: React.FC = () => {
  const navigate = useNavigate()
  return (
    <BaseView flex={1} gap={36} px={12}>
      <StickyHeaderNavigation onBackPress={() => navigate('/')} />
      <ChooseMethodHeader />
      <IdentificationMethods />
    </BaseView>
  )
}
